module.exports = __webpack_public_path__ + "static/media/carousel_quienes_somos_3.f755021e.jpg";